// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  v-icon {
    display: grid;
  }
  v-icon .icon {
    display: contents;
  }
  v-icon .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-icon/v-icon.component.sass"],"names":[],"mappings":"AAAA;EACI;IACI,aAAA;EACN;EAAM;IACI,iBAAA;EAEV;EADM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;EAGV;AACF","sourcesContent":["@layer vierkant\n    v-icon \n        display: grid\n        .icon\n            display: contents\n        .icon-container\n            display: flex\n            align-items: center\n            justify-content: center"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
